<template>
  <v-app transition="fade-transition">
    <v-card :class="`${isEditMode ? 'no-boxshadow' : ''}`" tile transition="fade-transition">
      <div :class="`${isCreateMode ? 'container container--fluid' : ''}`">
        <v-form ref="feedbackform" id="rate-card-form" v-model="valid" lazy-validation>
          <v-layout wrap justify-center mb-2>
            <v-flex :class="`content xs12 ${isCreateMode ? 'md7' : 'md12'}`">
              <v-row>
                <v-col cols="12" class="text-right pb-0">
                  <v-select
                    v-model="selectedLang"
                    item-text="title"
                    item-value="value"
                    :items="langOptions"
                    @change="changeLang()"
                    outlined
                    dense
                    style="max-width:100px;float:right;"
                  >
                    <template v-slot:item="{ item }">
                      <div><span :class="`fi ${item.icon}`"></span> {{ item.title }}</div>
                    </template>
                    <template v-slot:selection="{ item }">
                      <div><span :class="`fi ${item.icon}`"></span> {{ item.title }}</div>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row v-if="isCreateMode">
                <v-col cols="12" class="text-center pb-0">
                  <div class="avatar-logo">
                    <a href="https://www.getkobe.com" target="_blank">
                      <img :src="logoDataUrl" alt="KOBE Logo"/>
                    </a>
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <h2 class="form-title">{{formConfig.title}}</h2>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-col class="px-5 clearfix" cols="12">
                    <v-col class="col-xs-12 col-md-6">
                      <p class="h4 font-weight-bold mb-2">{{getLang('name')}} <span class="text-danger">*</span></p>
                      <v-text-field
                        class="purple-input"
                        v-model="rateCardData.name"
                        type="textbox"
                        outlined
                        required
                        hide-details
                        :error-messages="$v.rateCardData.name.$error && `Name is required.`"
                        @input="$v.rateCardData.name.$touch()"
                      />
                    </v-col>
                    <v-col class="col-xs-12 col-md-6">
                      <p class="h4 font-weight-bold mb-2">{{getLang('email')}}  <span class="text-danger">*</span></p>
                      <v-text-field
                        class="purple-input"
                        v-model="rateCardData.email"
                        type="email"
                        outlined
                        required
                        hide-details
                        :error-messages="$v.rateCardData.email.$error && (!$v.rateCardData.email.required ? 'Email is required.' : !$v.rateCardData.email.email ? 'Please enter a valid email address.' : '')"
                        @input="$v.rateCardData.email.$touch()"
                        @keydown.space.prevent
                        @paste="preventPasteSpaces" 
                      />
                    </v-col>
                    <v-col class="col-xs-12 col-md-6">
                      <p class="h4 font-weight-bold mb-2">{{getLang('dateOfBirth')}}</p>
                      <v-menu
                        ref="datePicker"
                        :close-on-content-click="false"
                        :return-value.sync="rateCardDOB"
                        v-model="DOBDateCal"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="rateCardData.dateOfBirth"
                            append-icon="event"
                            hide-details
                            outlined
                            v-on="on"
                            style="width:100%;"
                            readonly
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          id="rate-card-date-picker"
                          type="month"
                          :max="minBirthDate"
                          :show-current="minBirthDate"
                          v-model="rateCardData.dateOfBirth"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              color="secondary"
                              @click="DOBDateCal = false"
                          >
                              Cancel
                          </v-btn>
                          <v-btn
                              text
                              color="secondary"
                              @click="changeDate"
                          >
                              OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col class="col-xs-12 col-md-6">
                      <p class="h4 font-weight-bold mb-2">{{getLang('country')}} <span class="text-danger">*</span></p>
                      <v-select
                        class="pr-1"
                        :items="countries"
                        hide-details
                        outlined
                        v-model="rateCardData.country"
                        @change="changeCountry()"
                        required
                        :error-messages="$v.rateCardData.country.$error && `Country is required.`"
                        @input="$v.rateCardData.country.$touch()"
                      >
                      </v-select>
                    </v-col>
                    
                    <v-col class="col-xs-12 col-md-6" v-if="rateCardData.country === 'Singapore' || rateCardData.country === 'Malaysia'">
                      <p class="h4 font-weight-bold mb-2">{{getLang('ethnicity')}} <span class="text-danger">*</span></p>
                      <v-select
                        class="pr-1"
                        :items="ethnicityOptions"
                        hide-details
                        outlined
                        v-model="rateCardData.ethnicity"
                        required
                        :error-messages="$v.rateCardData.ethnicity.$error && `Ethnicity is required.`"
                        @input="$v.rateCardData.ethnicity.$touch()"
                      >
                      </v-select>
                      <v-text-field
                        v-if="rateCardData.ethnicity === 'Others'"
                        class="pr-1 mt-2"
                        outlined
                        hide-details
                        v-model="rateCardData.otherEth">
                      </v-text-field>
                    </v-col>
                    <!-- <v-col class="col-xs-12 col-md-6">
                      <p class="h4 font-weight-bold mb-2">{{getLang('city')}}</p>
                      <v-combobox
                        class="pr-1"
                        :items="citiesByCountry"
                        hide-details
                        outlined
                        v-model="rateCardData.city"
                      >
                      </v-combobox>
                    </v-col> -->
                    <v-col class="col-xs-12 col-md-6">
                      <p class="h4 font-weight-bold mb-2">{{getLang('gender')}} <span class="text-danger">*</span></p>
                      <v-select
                        class="purple-input"
                        :items="genderOptions"
                        v-model="rateCardData.gender"
                        type="textbox"
                        outlined
                        hide-details
                        required
                        :error-messages="$v.rateCardData.gender.$error && `Gender is required.`"
                        @input="$v.rateCardData.gender.$touch()"
                      ></v-select>
                    </v-col>
                    <v-col class="col-xs-12 col-md-6">
                      <p class="h4 font-weight-bold mb-2">{{getLang('ContactNo')}}</p>
                      <v-layout wrap>
                        <v-flex row style="padding-top: 12px;padding-left: 15px;">
                          <v-select
                            style="max-width:100px;border-radius:5px 0 0 5px"
                            v-model="countryCode"
                            :items="countryCodeOptions"
                            outlined
                          ></v-select>
                          <v-text-field
                            style="border-radius:0 5px 5px 0"
                            class="purple-input"
                            v-model="rateCardData.contactNo"
                            type="textbox"
                            outlined
                            hide-details
                          />
                        </v-flex>
                      </v-layout>
                    </v-col>
                    <v-col class="col-xs-12 col-md-6">
                      <p class="h4 font-weight-bold mb-2">{{getLang('occupation')}}</p>
                      <v-text-field
                        class="purple-input"
                        v-model="rateCardData.occupation"
                        type="textbox"
                        outlined
                        hide-details
                      />
                    </v-col>
                    <!-- <v-col class="col-xs-12 col-md-6">
                      <v-radio-group v-model="rateCardData.type" row hide-details>
                        <v-radio
                          value="direct"
                          label="Direct"
                          class="justify-center" >
                        </v-radio>
                        <v-radio
                        value="agency"
                        label="Agency"
                        class="justify-center"></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col class="col-xs-12 col-md-6" v-if="rateCardData.type === 'agency'">
                      <p class="h4 font-weight-bold mb-2">Agency Name</p>
                      <v-text-field
                        class="purple-input"
                        v-model="rateCardData.agencyName"
                        type="textbox"
                        outlined
                        hide-details
                      />
                    </v-col> -->
                  </v-col>
                  <v-col cols="12">
                    <v-col
                    :class="section.class ? section.class : 'xs12 md6'"
                    :style="section.style || ''"
                    v-for="(section, index) in formConfig.sections" :key="index">
                      <div>
                        <v-col 
                        class="align-center"
                        :class="field.class ? field.class : 'xs12 md6'"
                        :style="field.style || ''"
                        v-for="(field, index) in section.fields" :key="index">
                          <p style="min-height:39.59px;" :class="`h4 font-weight-bold mb-2 ${field.labelClass || ''}`"
                            v-if="field.label !== ''">
                            {{getLang(field.name)}} 
                            <span class="red--text" v-if="field.required">*</span>
                          </p>
                          <div class="d-flex flex-column" v-if="field.type === 'number'">
                            <div v-if="isEditMode && field.name === 'igStory'">
                              <p class="rate-label-title">Ordinary</p>
                            </div>
                            <div class="d-flex flex-row">
                              <v-select
                                class="currency-select"
                                style="margin-right: 5px;"
                                v-model.number="rateCardData.ordinaryRates[`${field.name}Currency`]"
                                :items="currenyOptions"
                                hide-details
                                dense
                                outlined
                              >
                              </v-select>
                               <v-text-field
                                class="purple-input"
                                v-model.number="rateCardData.ordinaryRates[field.name]"
                                type="number"
                                outlined
                                dense
                                :placeholder="field.placeholder ? field.placeholder : ''"
                              />
                            </div>
                          </div>
                          <div class="d-flex flex-column" v-if="field.type === 'number' && isEditMode">
                            <div v-if="field.name === 'igStory'">
                              <p class="rate-label-title pl-3">Preferential</p>
                            </div>
                            <div class="d-flex flex-row pl-3">
                              <v-select
                                class="currency-select"
                                style="margin-right: 5px;"
                                v-model.number="rateCardData.preferentialRates[`${field.name}Currency`]"
                                :items="currenyOptions"
                                hide-details
                                dense
                                outlined
                              >
                              </v-select>
                               <v-text-field
                                class="purple-input"
                                v-model.number="rateCardData.preferentialRates[field.name]"
                                type="number"
                                outlined
                                dense
                                :placeholder="field.placeholder ? field.placeholder : ''"
                              />
                            </div>
                          </div>
                          <v-text-field
                            class="purple-input"
                            v-model="rateCardData[field.name]"
                            type="textbox"
                            outlined
                            :style="field.fieldStyle || ''"
                            v-if="field.type === 'textbox' && (field.name !== 'instagramHandle' && field.name !== 'tiktokHandle')"
                            :placeholder="field.placeholder ? field.placeholder : ''"
                          />
                          <v-text-field
                            class="purple-input social-handle-input"
                            v-model="rateCardData[field.name]"
                            type="textbox"
                            outlined
                            :style="field.fieldStyle || ''"
                            prefix="@"
                            v-if="field.type === 'textbox' && (field.name === 'instagramHandle' || field.name === 'tiktokHandle')"
                            :placeholder="field.placeholder ? field.placeholder : ''"
                          />
                          <v-text-field
                            class="purple-input"
                            v-model="rateCardData[field.name]"
                            @keypress="onlyForNumber"
                            type="number"
                            outlined
                            :style="field.fieldStyle || ''"
                            v-if="field.type === 'normalNumber'"
                            :placeholder="field.placeholder ? field.placeholder : ''"
                          />
                          <v-textarea
                            filled
                            auto-grow
                            :hint="field.hint || ''"
                            :persistent-hint="field.hint ? true : false"
                            :placeholder="field.placeholder"
                            v-model="rateCardData[field.name]"
                            required
                            v-if="field.type === 'textarea'"
                            hide-details="auto"
                          ></v-textarea>
                          <custom-file-upload
                            :refresh="fileUploadRefresh"
                            :multiple="true"
                            @setMedias="updatePricingDecks"
                            v-if="field.type === 'file'"
                          />
                          <div v-if="field.type === 'multiple'">
                            <div class="social-platform-list">
                              <div
                                v-for="(multipleOne, pIndex) in rateCardData[field.name]"
                                :key="pIndex"
                                class="social-platform-entry"
                              >
                                <div class="social-platform-main">
                                  <v-select
                                    class="social-platform-select"
                                    :items="field.options[0].options"
                                    item-value="value"
                                    item-text="label"
                                    hide-details
                                    v-model="rateCardData[field.name][pIndex].platform"
                                    :label="field.options[0].label"
                                    dense
                                    outlined
                                  />
                                  <v-text-field
                                    class="social-platform-url"
                                    dense
                                    outlined
                                    hide-details
                                    :placeholder="field.options[1].placeholder"
                                    v-model="rateCardData[field.name][pIndex].url"
                                  />
                                  <v-btn
                                    class="social-platform-delete"
                                    @click="rateCardData[field.name].splice(pIndex, 1)"
                                    icon
                                    small
                                    aria-label="Remove platform"
                                  >
                                    <v-icon color="error">mdi-delete-forever</v-icon>
                                  </v-btn>
                                </div>
                                <v-text-field
                                  v-if="rateCardData[field.name][pIndex][field.child.parentName] === 'others'"
                                  class="social-platform-other"
                                  dense
                                  outlined
                                  hide-details
                                  :placeholder="field.child.placeholder"
                                  v-model="rateCardData[field.name][pIndex][field.child.name]"
                                />
                                <div class="social-platform-rate">
                                  <v-select
                                    class="currency-select-multiple"
                                    v-model.number="rateCardData[field.name][pIndex].rateCurrency"
                                    :items="currenyOptions"
                                    hide-details
                                    dense
                                    outlined
                                  />
                                  <v-text-field
                                    class="multiple-rate"
                                    type="number"
                                    dense
                                    outlined
                                    hide-details
                                    placeholder="Rate"
                                    v-model.number="rateCardData[field.name][pIndex].rate"
                                  />
                                </div>
                              </div>
                              <div class="text-right">
                                <v-btn
                                  small
                                  color="secondary"
                                  @click="addPlatform(field.name)"
                                >
                                  <v-icon small>mdi-plus</v-icon> Add
                                </v-btn>
                              </div>
                            </div>
                          </div>
                        </v-col>
                      </div>
                    </v-col>
                  </v-col>
                  <!-- required field messaage -->
                  <v-row v-if="!rateCardData.instagramHandle && !rateCardData.tiktokHandle">
                    <v-col cols="12" class="pb-0 px-5 mx-3">
                      <p class="text-danger font-weight-bold" style="font-style:italic">{{getLang('enterIgTikTok')}} *</p>
                    </v-col>
                  </v-row>
                  <!-- END required field messaage -->
                  <v-col class="px-5" cols="12">
                    <v-col class="col-xs-12 col-md-12">
                      <p class="h4 font-weight-bold mb-2">{{getLang('preferredCampaigns')}}</p>
                      <v-chip-group multiple active-class="secondary white--text" v-model="rateCardData.keywords" column required>
                        <v-chip v-for="(item, index) in categories" :key="index" :value="item"      
                          class="ma-2"                               
                          filter                                                                                                                                                             
                        >
                          {{item}}
                        </v-chip>
                      </v-chip-group>
                      <span class="red--text" v-if="rateCardData.keywords !== null && !rateCardData.keywords.length">{{getLang('preferredCampaigns')}}</span>
                    </v-col>
                    <v-col class="col-xs-12 col-md-12">
                      <p class="h4 font-weight-bold mb-2">{{getLang('bestRepresent')}} <span class="text-danger">*</span></p>
                      <!-- <v-text-field
                        class="purple-input"
                        v-model="rateCardData.aboutYou"
                        type="textbox"
                        outlined
                        :error-messages="$v.rateCardData.aboutYou.$error && `One liner about you is required.`"
                        @input="$v.rateCardData.aboutYou.$touch()"
                      /> -->
                      <v-textarea
                        filled
                        auto-grow
                        v-model="rateCardData.aboutYou"
                        required
                        hide-details="auto"
                        :error-messages="$v.rateCardData.aboutYou.$error && `This field is required.`"
                        @input="$v.rateCardData.aboutYou.$touch()"
                      ></v-textarea>
                    </v-col>

                    <!-- <v-col class="col-xs-12 col-md-12">
                      <p class="h4 font-weight-bold mb-2">{{getLang('loadContent')}}</p>
                      <v-radio-group v-model="rateCardData.loadContent">
                        <v-radio value="Yes" :label="getLang('yes')" class="justify-center"></v-radio>
                        <v-radio value="No" :label="getLang('no')" class="justify-center"></v-radio>
                      </v-radio-group>
                      <v-text-field
                        class="px-2"
                        style="max-width:300px"
                        dense
                        outlined
                        hide-details
                        v-model="rateCardData.loadContentText"
                        v-if="rateCardData.loadContent === 'No'">
                      </v-text-field>
                    </v-col> -->

                    <v-col class="col-xs-12 col-md-12">
                      <p class="h4 font-weight-bold mb-2">{{getLang('giftBrand')}}</p>
                      <v-radio-group v-model="rateCardData.giftBrand" color="secondary">
                        <v-radio value="Yes" :label="getLang('yes')" class="justify-center" color="secondary"></v-radio>
                        <v-radio value="No" :label="getLang('noPaidCampaign')" class="justify-center" color="secondary"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-col>
                </v-col>
                <!-- <v-col class="px-5" cols="12">
                  <v-col class="col-xs-12 col-md-6">
                    <p class="h4 font-weight-bold mb-2">Country</p>
                    <v-select
                      class="pr-1"
                      :items="countries"
                      hide-details
                      outlined
                      v-model="rateCardData.country"
                    >
                    </v-select>
                  </v-col>
                  <v-col class="col-xs-12 col-md-6">
                    <v-radio-group class="mt-0" style="margin-bottom:10px" v-model="rateCardData.type" row hide-details>
                      <v-radio value="agency" label="Agency" class="justify-center"></v-radio>
                      <v-radio
                        value="direct"
                        label="Direct"
                        class="justify-center" >
                      </v-radio>
                    </v-radio-group>
                    <v-text-field
                      class="purple-input"
                      label="Agency Name"
                      v-if="rateCardData.type === 'agency'"
                      v-model="rateCardData.agencyName"
                      type="textbox"
                      outlined
                      hide-details
                    />
                  </v-col>
                </v-col> -->
              </v-row>
              <!-- End Section One -->

              <v-row>
                <v-col cols="12" class="d-flex justify-space-between align-center">
                  <div v-if="$route.query.cc" class="text-left">
                    <span class="font-weight-bold">Referred By:</span> {{ $route.query.cc }}
                  </div>
                  <div v-else></div>
                  <v-btn :disabled="submitting" class="secondary" x-large @click.prevent="submitForm">
                    <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i> Submit
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col>
                </v-col>
              </v-row> -->
            </v-flex>
          </v-layout>
        </v-form>
      </div>
    </v-card>
    <rate-card-terms-modal
      v-model="showAgreementModal"
      :value="showAgreementModal"
      :selectedLang="selectedLang"
      @termsAggrement="confirmSave"
    />
  </v-app>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex';
import config from '@/config';
import rateCardConfig from './config';
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import CustomFileUpload from '../../../scoped/custom/CustomFileUpload';
import influencerHelper from '../influencerHelper'
// import influencerAPIs from '../influencerAPIs'
import utils from '@/utils'
import moment from 'moment';
import cities from '../../../../../static/sources/cities';
import dialCodes from '../../../../../static/sources/dialCodes';
import RateCardTermsModal from './RateCardTermsModal'
import 'flag-icons/css/flag-icons.min.css'
import logoDataURL from "@/config/logoDataURL";

export default {
  name: 'RateCardForm',
  mixins: [validationMixin],
  validations: function() {
    const validationRules = {
      rateCardData: {
        name: {
          required
        },
        email: {
          required,
          email
        },
        country: {
          required
        },
        ethnicity: {
          requiredIfSpecificCountry: (value) => {
            const country = this.rateCardData.country
            if (country === 'Singapore' || country === 'Malaysia') {
              return value && value.length > 0
            }
            return true
          }
        },
        gender: {
          required
        },
        // loadContent: {
        //   required
        // },
        // occupation: {
        //   required
        // },
        aboutYou: {
          required
        }
        // keywords: {
        //   required
        // }
      }
    };
    // this.formConfig.sections.forEach(field => {
    //   if (field.fields) {
    //     field.fields.forEach(sectionField => {
    //       if (!sectionField.multiple) {
    //         validationRules['rateCardData'][sectionField.name] = sectionField.required ? {required} : '';
    //       }
    //     })
    //   }
    // })
    return validationRules
  },
  components: {
    CustomFileUpload,
    RateCardTermsModal
  },
  props: {
    mode: String,
    editData: Object
  },
  data () {
    return {
      logoDataUrl: logoDataURL.logo || '/static/img/kobe_bg_main.png',
      dialog: true,
      rateCardDOB: false,
      formConfig: rateCardConfig.formConfig,
      langs: rateCardConfig.langs,
      countryCodeOptions: dialCodes.map(d => d.dc),
      genderOptions: [
        'Male',
        'Female'
      ],
      ethnicityOptions: [
        'Chinese',
        'Malay',
        'Indian',
        'Eurasian',
        'Others'
      ],
      rateCardData: {
        platforms: [],
        keywords: [],
        type: 'direct',
        agencyName: '',
        country: 'Singapore',
        city: '',
        ethnicity: '',
        otherEth: '',
        contactNo: '',
        gender: '',
        dateOfBirth: '',
        loadContent: '',
        loadContentText: '',
        giftBrand: '',
        igFollowerCount: '',
        tiktokFollowerCount: '',
        // igAvgViews: '',
        // tiktokAvgViews: '',
        preferentialRates: {
          igStory: 0,
          igStoryCurrency: 'SGD',
          igPost: 0,
          igPostCurrency: 'SGD',
          igCarousel: 0,
          igCarouselCurrency: 'SGD',
          igVideo: 0,
          igVideoCurrency: 'SGD',
          igReel: 0,
          igReelCurrency: 'SGD',
          igTv: 0,
          igTvCurrency: 'SGD',
          loadingFee: 0,
          loadingFeeCurrency: 'SGD',
          eventAppearance: 0,
          eventAppearanceCurrency: 'SGD',
          tiktok: 0,
          tiktokCurrency: 'SGD'
        },
        ordinaryRates: {
          igStory: 0,
          igStoryCurrency: 'SGD',
          igPost: 0,
          igPostCurrency: 'SGD',
          igCarousel: 0,
          igCarouselCurrency: 'SGD',
          igVideo: 0,
          igVideoCurrency: 'SGD',
          igReel: 0,
          igReelCurrency: 'SGD',
          igTv: 0,
          igTvCurrency: 'SGD',
          loadingFee: 0,
          loadingFeeCurrency: 'SGD',
          eventAppearance: 0,
          eventAppearanceCurrency: 'SGD',
          tiktok: 0,
          tiktokCurrency: 'SGD'
        }
      },
      deckFiles: [],
      fileUploadRefresh: false,
      submitting: false,
      categories: [],
      countries: [],
      citiesByCountry: [],
      dialCodes,
      currenyOptions: rateCardConfig.currencyOptions,
      langOptions: [
        {
          icon: 'fi-gb-eng',
          title: 'EN',
          value: 'en'
        },
        {
          icon: 'fi-th',
          title: 'TH',
          value: 'th'
        },
        {
          icon: 'fi-vn',
          title: 'VN',
          value: 'vn'
        },
        {
          icon: 'fi-id',
          title: 'ID',
          value: 'id'
        },
        {
          icon: 'fi-cn',
          title: 'CN',
          value: 'cn'
        },
        {
          icon: 'fi-jp',
          title: 'JP',
          value: 'jp'
        }
      ],
      selectedLang: 'en',
      minBirthDate: moment().subtract(13, 'years').format('YYYY-MM-DD'),
      DOBDateCal: false,
      showAgreementModal: false
    }
  },
  watch: {
    editData(newValue) {
      if (newValue) {
        this.rateCardData = Object.assign({}, this.editData)
        if (this.rateCardData.contactNo) {
          // empty dial code and set country set option
          for (let code of this.countryCodeOptions) {
            if (this.rateCardData.contactNo.includes(code)) {
              this.rateCardData.contactNo = this.rateCardData.contactNo.replaceAll(code, '')
              this.countryCode = code
            }
          }
        }
      }
    },
    selectedLang(newValue) {
      this.updateCategories(newValue)
    }
  },
  methods: {
    close() {
      this.$router.push({path: '/'})
    },
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    },
    submitForm() {
      this.showAgreementModal = false
      this.$v.$touch()
      if (this.$v.rateCardData.$error) {
        return false
      }
      if (!this.rateCardData.instagramHandle && !this.rateCardData.tiktokHandle) {
        this.$swal({
          text: this.getLang('enterIgTikTok'),
          type: 'warning'
        });
        return
      }
      // if (this.rateCardData.instagramHandle && !this.rateCardData.igFollowerCount) {
      //   this.$swal({
      //     text: 'Please enter Instagram Followers Count!',
      //     type: 'warning'
      //   });
      //   return
      // }
      // if (this.rateCardData.tiktokHandle && !this.rateCardData.tiktokFollowerCount) {
      //   this.$swal({
      //     text: 'Please enter TikTok Followers Count!',
      //     type: 'warning'
      //   });
      //   return
      // }
      if (!this.rateCardData.keywords.length) {
        this.$swal({
          text: 'Please select preferred type of campaigns/genre!',
          type: 'warning'
        });
        return
      }

      // First Check: Instagram rates validation
      if (this.rateCardData.instagramHandle) {
        const igRates = this.rateCardData.ordinaryRates
        const igFieldsEmpty = !igRates.igStory && !igRates.igPost && !igRates.igCarousel && 
                              !igRates.igVideo && !igRates.igReel && !igRates.igTv && 
                              !igRates.loadingFee && !igRates.eventAppearance
        
        if (igFieldsEmpty) {
          this.$swal({
            text: 'Please enter IG Rates',
            type: 'warning'
          });
          return
        }
      }

      // Second Check: TikTok rates validation
      if (this.rateCardData.tiktokHandle) {
        const tiktokRate = this.rateCardData.ordinaryRates.tiktok
        
        if (!tiktokRate) {
          this.$swal({
            text: 'Please enter TikTok Rates',
            type: 'warning'
          });
          return
        }
      }

      this.showAgreementModal = true
    },
    confirmSave() {
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.submitting = true;
          const formData = this.constructData();
          await this.$store.dispatch('influencer/saveCreatorCommunity', formData)
          if (this.savedCreatorCommunity) {
            // Dismiss modal by triggering the click event on Close button
            // this.close();
            // Update submitting status
            this.submitting = false;
            // Show success message
            this.$swal({
              text: `Community Form ${this.rateCardData.id ? 'Updated' : 'Submitted'}`,
              type: 'success'
            }).then(result => {
              window.location.href = 'https://getkobe.com'
            })
          } else {
            // Update submitting status
            this.submitting = false;
            this.$swal({
              text: 'Error saving Community Form.',
              type: 'error'
            });
          }
        }
      });
    },
    constructData() {
      let saveData = Object.assign({}, this.rateCardData);
      saveData.lang = this.selectedLang
      saveData.instagramHandle = saveData.instagramHandle ? utils.func.espaceHandleSign(utils.func.regexMatchIg(saveData.instagramHandle, config.regexPattern.instagram_profile)) : ''
      saveData.tiktokHandle = saveData.tiktokHandle ? utils.func.espaceHandleSign(utils.func.extractTikTokHandle(saveData.tiktokHandle)) : ''
      saveData.contactNo = `${this.countryCode}${saveData.contactNo}`
      let formData = new FormData();
      formData.append('data', JSON.stringify(saveData))
      for (let val of this.deckFiles) {
        formData.append('uploadFile', val);
      }
      return formData;
    },
    updatePricingDecks(medias) {
      this.deckFiles = Object.assign([], medias)
    },
    addPlatform(fieldName) {
      this.rateCardData[fieldName].push({
        platform: '',
        url: '',
        rate: '',
        rateCurrency: 'SGD'
      })
    },
    changeDate() {
      this.$refs.datePicker.save(this.rateCardData.dateOfBirth);
    },
    changeCountry() {
      let optionOne = this.dialCodes.find(o => o.cn === this.rateCardData.country)
      if (optionOne) {
        this.countryCode = optionOne.dc
      }
      this.rateCardData.city = ''
      // find city
      this.citiesByCountry = []
      let selectedCities = cities[this.rateCardData.country]
      if (Array.isArray(selectedCities)) {
        this.citiesByCountry = Object.assign([], selectedCities)
      }
      this.setCurrencyOptionsOnLang()
    },
    getLang(attr) {
      return this.langs[this.selectedLang][attr] || ''
    },
    updateCategories(newValue) {
      this.categories = influencerHelper.getCategories(newValue)
    },
    setLangParam() {
      let queries = this.$route.query
      queries.lang = this.selectedLang
      // Build query string from queries object
      const queryString = Object.keys(queries)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queries[key])}`)
        .join('&')
      window.location.href = `${window.location.pathname}?${queryString}`
    },
    setCurrencyOptionsOnLang() {
      // Define currency options for different languages
      const currencyOptions = [
        { lang: 'Singapore', value: 'SGD' },
        { lang: 'en', value: 'USD' },
        { lang: 'Indonesia', value: 'IDR' },
        { lang: 'Philippines', value: 'PHP' },
        { lang: 'Thailand', value: 'THB' },
        { lang: 'Malaysia', value: 'MYR' },
        { lang: 'Vietnam', value: 'VND' },
        { lang: 'Japan', value: 'JPY' }
      ]
      
      // Set currency for preferentialRates and ordinaryRates based on selected language
      const selectedCurrency = currencyOptions.find(option => option.lang === this.rateCardData.country)
      if (selectedCurrency) {
        const currencyValue = selectedCurrency.value
        const currencyFields = [
          'igStoryCurrency',
          'igPostCurrency',
          'igCarouselCurrency',
          'igVideoCurrency',
          'igReelCurrency',
          'igTvCurrency',
          'loadingFeeCurrency',
          'eventAppearanceCurrency',
          'tiktokCurrency'
        ]
        
        currencyFields.forEach(field => {
          this.rateCardData.preferentialRates[field] = currencyValue
          this.rateCardData.ordinaryRates[field] = currencyValue
        })
      }
    },
    changeLang() {
      this.setLangParam()
    },
    onlyForNumber($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // only allow number
      if (keyCode < 48 || keyCode > 57) { // 46 is dot
        $event.preventDefault();
      }
    }
  },
  computed: {
    ...mapState({
      savedCreatorCommunity: state => state.influencer.savedCreatorCommunity
    }),
    currentUserID: function () {
      return this.$store.state.user.id
    },
    isCreateMode: function () {
      return !this.mode
    },
    isEditMode: function () {
      return this.mode === 'edit'
    }
  },
  mounted() {
    if (this.$route.query.lang) {
      this.selectedLang = this.$route.query.lang
      // this.setCurrencyOptionsOnLang()
    }
    if (this.$route.query.name) {
      this.rateCardData.name = this.$route.query.name
    }
    if (this.$route.query.email) {
      this.rateCardData.email = this.$route.query.email
    }
    if (this.$route.query.influencerID) {
      this.rateCardData.influencerID = this.$route.query.influencerID
    }
    if (this.$route.query.sourceid) {
      this.rateCardData.sourceID = this.$route.query.sourceid
    }
    this.addPlatform('platforms')
    // Retrieve countries from config
    this.countries = rateCardConfig.targetCountries
    this.changeCountry()
    this.updateCategories(this.selectedLang)
    // this.setLangParam()
  }
}
</script>
<style lang="scss">
  .v-dialog--fullscreen {
    scroll-behavior: smooth;
  }
  #rate-card-form .multiple-rate .v-text-field__prefix {
    font-size: 11px;
  }
  #rate-card-form .currency-select .v-input__slot {
    padding: 0;
    padding-left: 5px;
  }
  #rate-card-form .social-handle-input.v-input--is-focused .v-text-field__prefix {
    color: var(--ims-color-secondary) !important;
  }
  #rate-card-form .currency-select-multiple {
    min-width: 115px;
    max-width: 115px;
  }
  #rate-card-form .more-platform-label {
    margin-bottom: -15px!important;
  }
  #rate-card-date-picker .v-picker__actions.v-card__actions {
    background: #fff!important;
  }
</style>
<style scoped>
  html {
    overflow-y: hidden!important;
  }

  .bg-soft-grey {
    background-color: #f6f6f6;
  }

  .bg--white {
    background-color: #fff;
  }

  .v-text-field-sm{
    width: 320px;
  }

  .form-label {
    min-height: 22px;
  }

  .caption-text {
    color: #f79d18;
  }

  /* .td-error {
    margin-bottom: -20px;
    right: 16px;
  } */

  .td-error, .alert-error {
    display: inline-block;
    font-size: 12px;
    right: 15px;
    padding: 5px;
    margin-bottom: 0px;
    color: #fff!important;
  }

  .alert-error {
    right: 0
  }

  .checkboxes-error {
    margin-top: -15px;
  }

  .d-sm-table-cell {
    height: auto!important;
    padding: 0;
    padding-left: 15px;
  }

  .v-card {
    background-color: rgb(204, 204, 204)!important;
  }

  .content {
    max-width: 100%!important;
    background-color: #fff;
    padding: 20px;
  }

  .avatar-logo {
    width: 120px!important;
    min-width: 120px!important;
    height: auto!important;
    transition: all 0.5s ease-out;
    margin: 0 auto;
  }

  .avatar-logo img {
    width: 120px;
  }
  
  .form-title {
    margin-top: 0;
    text-align: center;
    font-weight: 600;
    /* padding: 40px; */
    transition: all 0.5s ease-out;
  }

  .label-stats {
    min-width: 150px;
    margin:0px;
  }

  .edit-rate-card-form .label-stats {
    min-width: 150px;
  }

  .edit-rate-card-form .rate-label-title {
    margin-top:-10px;
    font-weight: bold;
  }

  .event-att-section {
    margin-top: 100px;
  }

  .currency-select {
    width: 100px;
    font-size: 12px;
  }

  .no-boxshadow {
    box-shadow: none!important;
  }

  .social-platform-list {
    margin-top: 12px;
  }

  .social-platform-entry {
    margin-bottom: 12px;
    padding: 12px;
    border: 1px solid #dedede;
    background-color: #fafafa;
  }

  .social-platform-main {
    display: grid;
    grid-template-columns: minmax(112px, 0.8fr) minmax(0, 1.8fr) 32px;
    gap: 8px;
    align-items: start;
  }

  .social-platform-delete {
    margin-top: 0;
  }

  .social-platform-other {
    margin-top: 8px;
  }

  .social-platform-rate {
    display: grid;
    grid-template-columns: 115px minmax(0, 150px);
    gap: 8px;
    margin-top: 8px;
  }

  @media (max-width: 768px) {
    .content {
      padding: 20px;
    }
  }
  
  @media (max-width: 600px) {
    .content {
      padding: 0;
    }
    .avatar-logo {
      height: auto!important;
      min-width: 100%!important;
      width: 100%!important;
    }
    
    .form-title {
      float: none;
      padding: 0;
      font-size: 25px;
      width: 100%;
      text-align: center;
    }

    .float-xs-left {
      float: left;
    }

    .td-error, .alert-error {
      width: 100%;
      right: 0;
    }

    .pt-xs-5 {
      padding-top: 15px
    }

    .mb-xs-0 {
      margin-bottom: 0;
    }

    .social-platform-main {
      grid-template-columns: minmax(0, 1fr) 32px;
    }

    .social-platform-url {
      grid-column: 1 / -1;
    }
  }

  /* @media (max-width: 400px) {
    .platform-select {
      min-width: 50px!important;
      max-width: 50px!important;
    }
  } */

  @media (min-width: 1000px) and (max-width: 1366px) {
    .content {
      flex-basis: 90%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// Form.vue?f7fa0050